export const doesExistInArray = (items = [], lookup = [], key = null) =>
  items.some((item) => lookup.includes(key ? item?.[key] : item));
